/**
 * Formats a percentage value to always display with exactly 2 decimal places.
 * Accepts both numeric values and string values with % suffix.
 *
 * @example
 * formatPercentageValue(24.5)    // "24.50%"
 * formatPercentageValue(12)      // "12.00%"
 * formatPercentageValue("7.9%")  // "7.90%"
 * formatPercentageValue("14.006%") // "14.01%"
 */
export function formatPercentageValue(value: number | string): string {
  const numericValue =
    typeof value === "string" ? parseFloat(value.replace("%", "")) : value

  return (
    numericValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + "%"
  )
}
